import $ from "jquery";
import Hammer from "hammerjs";
import * as JS from "./vendor/lanyard/socket";
import * as Sailcloth from "./vendor/sailcloth/sailcloth";
import Cookie from "js-cookie";
import debounce from "debounce";
import { Board } from "./board";
import { BoardDataSource } from "./board-data-source";
import { PlayerTiles } from "./player-tiles";
import * as Dialogs from "./dialogs";
import * as Chrome from "./chrome";
import lurl from "./lurl";
// not sure what the best place for this universal stuff is?
if ("ontouchstart" in window || navigator.maxTouchPoints) {
    $("body").addClass("has-touch");
}
// windows has serious problems when touch is enabled - just assume the
// user has a mouse
if (navigator.userAgent.includes("Windows NT")) {
    $("body").removeClass("has-touch");
}
export class App {
    constructor(options) {
        const view = document.getElementById("board-view");
        if (!view) {
            throw "error: could not load canvas element from dom";
        }
        this.viewport = new Sailcloth.WorldViewport(view, {
            onRedraw: () => this.update(),
        });
        this.options = options || {};
        this.isFirstLoad = true;
        this.isUsingMouse = false;
        this._gameState = "new";
        this.isLoading = false;
        this._ping = 0;
        this.heartbeatDate = Date.now();
        this.socket = this.initializeSocket();
        this.loadingIndicator = new Chrome.LoadingIndicator();
        this.viewport.add(this.loadingIndicator);
        // do a refresh just after the load - this is needed because it might take
        // some time for css to load the font etc.
        setTimeout(() => this.viewport.refresh(), 1500);
        this.board = new Board({
            lang: this.options.user.lang,
            dataSource: new BoardDataSource({
                socket: this.socket,
                tileBlockSize: this.options.tile_block_size,
                letterValues: this.options.letter_values,
                onDataChanged: () => {
                    $("#loading").hide();
                    this.viewport.refresh();
                },
                // this is triggered when a external user makes a move. In this case
                // we need to update the data (already taken care of by the DS), and check
                // for some special cases
                onTilesPlayed: data => {
                    const m = data.moves[0];
                    this.floatingAlertForBox(`+${data.score_change} ${data.username}`, m.bx, m.by);
                    this.playerArrows.recordMove(data.username, m.bx, m.by);
                    let hasPendingChanged = false;
                    // we need to check each of the player moves to make sure they
                    // don't sit in the same location as one of our pending tiles
                    for (const move of data.moves) {
                        if (this.board.dataSource.isPending(move.bx, move.by)) {
                            // another player has made a move that overwrites one of our pending
                            // letters - we remove it and put it back in the
                            const letter = this.board.dataSource.clearPending(move.bx, move.by);
                            this.playerTiles.append(letter || "");
                            hasPendingChanged = true;
                        }
                    }
                    if (hasPendingChanged) {
                        this.updateActionButtons();
                    }
                },
            }),
        });
        this.viewport.add(this.board);
        this.playerArrows = new Chrome.PlayerArrows(this.board);
        this.viewport.add(this.playerArrows);
        this.viewport.setCenter(0, 0);
        this.applyLocalSettings();
        $("body").addClass(`lang-${this.options.user.lang || "en"}`);
        // if there is no touch on this device (ie it is a desktop), then we want to
        // activate some slightly different controls, navigation with the keyboard,
        // for example
        if (!$("body").hasClass("has-touch")) {
            this.isUsingMouse = true;
            this.initializeDesktopControls();
        }
        this.initializeActionButtons();
        this.initializePlayerTiles();
        this.initializeDialogs();
        this.initializeHeartbeat();
        if (this.options.show_start_dialog) {
            this._startDialog.show();
        }
    }
    initializeActionButtons() {
        // this needs to be done otherwise they will be active for
        // dragging - I think sortablejs does this...
        $("#main .button").attr("draggable", "false");
        $("a.button.buy").click(e => {
            this.collapseMenus();
        });
        $("a.button.buy-tswap").click(e => {
            this.buyDialog.show();
        });
        $("a.button.buy-letter").click(e => {
            this.buyLetterDialog.show();
        });
        $("a.button.buy-menu").click(e => {
            if ($(e.target).hasClass("open")) {
                $(e.target).removeClass("open");
                $(".button.buy").hide();
            }
            else {
                $(e.target).addClass("open");
                $(".button.buy").show();
            }
        });
        $("a.button.recall").click(e => {
            this.resetPending();
        });
        $("a.button.zoom").click(e => {
            // before toggling the zoom we need to get the coords
            // of the box at the center of the screen, so that we can
            // recenter on it again afterwards
            const p = this.viewport.center;
            const b = this.board.boxAt(p.x, p.y);
            this.board.toggleZoom();
            // after toggling the zoom, we need to recenter the board so that the
            // same box that was under the cursor is there again
            const rect = this.board.rectForBox(b.bx, b.by);
            this.viewport.setCenter(rect.center.x, rect.center.y);
            this.viewport.refresh();
        });
        $("a.button.commit").click(e => {
            this.commitMove();
        });
        $("a.button.time").click(e => {
            this.gameStartDialog.show();
        });
    }
    get isLocal() {
        return (this._isLocal = this._isLocal || $("body").hasClass("is-local"));
    }
    resetPending() {
        const removedLetters = this.board.dataSource.resetPending();
        this.board.clearSelectedLetter();
        this.playerTiles.append(removedLetters);
        this.updateActionButtons();
        this.viewport.refresh();
    }
    initializeHeartbeat() {
        // the heart beat process is designed to know how long we have
        // been disconnected for, this is mainly an issue on mobile, because
        // the app can be backgrouped at any time
        setInterval(() => {
            if (this.socket && this.socket.isConnected()) {
                const ageMs = Date.now() - this.heartbeatDate;
                if (ageMs / 1000 > 15.0) {
                    this.onReanimate(ageMs);
                }
                this.heartbeatDate = Date.now();
            }
            if (this.viewport) {
                this.viewport.refresh();
            }
        }, 1500);
    }
    initializePlayerTiles() {
        // set up the play tiles bar to allow selecting them
        this.playerTiles = new PlayerTiles({
            letterValues: this.options.letter_values,
        });
        this.playerTiles.$.click(() => this.board.clearSelectedLetter());
        this.socket.on("new_letters", s => this.playerTiles.append(s));
        // unlike new_letters, reset_letters clears all the tiles and replaces them
        // it doesn't append - this way the state will exactly match the server
        this.socket.on("reset_letters", s => {
            this.resetPending();
            this.playerTiles._letters = [];
            this.playerTiles.append(s);
            // the server will not always have a full set of tiles, for new users
            // they will be sent an empty set, and then have to request new ones
            this.requestLettersIfNeeded();
        });
    }
    initializeDialogs() {
        this._startDialog = new Dialogs.StartDialog(".dialog.leaders", {
            onOpen: (dialog) => {
                const username = this.options.user.username;
                dialog.$.find(".name-form input[type=text]").val(username);
            },
            onSubmit: (dialog) => {
                const username = dialog.$.find("input[type=text]").val();
                if (username == "" || username == this.options.user.username) {
                    return;
                }
                this.socket.send("set_username", username).then(data => {
                    this.options.user.username = username;
                    console.log(`username changed to ${username}`);
                });
            },
        });
        $(".button.hamburger").click(() => this._startDialog.show());
        $("a.buy-more-link").click(() => {
            $(".dialog").hide();
            this.creditDialog.show();
        });
        /*
            let g = new Dialogs.GameOverDialog('.dialog.game-over');
            g.score = 100;
            g.ms = 131 * 1000;
            g.show();
            */
    }
    get buyLetterDialog() {
        if (this._buyLetterDialog) {
            return this._buyLetterDialog;
        }
        return (this._buyLetterDialog = new Dialogs.BuyLetterDialog(".dialog.buy.letter", {
            socket: this.socket,
            onPurchaseComplete: (r, d) => this.onPurchaseComplete(r, d),
        }));
    }
    get buyDialog() {
        if (this._buyDialog) {
            return this._buyDialog;
        }
        return (this._buyDialog = new Dialogs.BuyDialog(".dialog.buy.tswap", {
            socket: this.socket,
            onPurchaseComplete: (r, d) => this.onPurchaseComplete(r, d),
        }));
    }
    get creditDialog() {
        return (this._creditDialog =
            this._creditDialog || new Dialogs.Dialog(".dialog.credits", {}));
    }
    get gameDialog() {
        return (this._gameDialog =
            this._gameDialog ||
                new Dialogs.GameOverDialog(".dialog.game-over", {
                    onSubmit: (d) => this.socket.send("start_game"),
                }));
    }
    get gameStartDialog() {
        return (this._gameStartDialog =
            this._gameStartDialog ||
                new Dialogs.Dialog(".dialog.game-start", {
                    onSubmit: (d) => {
                        this.socket.send("start_game");
                    },
                    onOpen: (d) => {
                        d.$.find(".scores").load(lurl("/users/timed_leader_board"), () => d.center());
                    },
                }));
    }
    collapseMenus() {
        $(".button.buy-menu").removeClass("open");
        $(".button.buy").hide();
    }
    onPurchaseComplete(response, dialog) {
        dialog.isLoading = false;
        if (response.status == "ok") {
            dialog.hide();
            //this.flashAlert(`>${response.item_code}< -${response.cost}CR`);
            return;
        }
        else if (response.status == "no_credit") {
            dialog.hide();
            if (!this.isLocal) {
                this.creditDialog.show();
            }
        }
        else {
            console.log(response);
        }
    }
    // thi s method is called when the app has been in the background
    // for a long time, and not getting events from the server. In this case
    // we want to do a few things to make sure the client has up to date data
    onReanimate(sinceLastHeartbeat) {
        console.log(`disconnected for: ${sinceLastHeartbeat / 1000}s`);
        this.board.dataSource.invalidateAll();
        this.viewport.refresh();
    }
    commitMove() {
        if (this.isLoading) {
            return;
        }
        this.isLoading = true;
        const always = () => {
            this.isLoading = false;
            this.updateActionButtons();
            this.viewport.refresh();
        };
        this.board.dataSource
            .commitPending()
            .then(response => {
            this.onWordSuccessful(response);
            always();
        })
            .catch(ex => {
            always();
            if (ex.invalid_words && ex.invalid_words.length > 0) {
                this.flashAlert(`sorry, '${ex.invalid_words[0]}' isn't a word`, 2000);
            }
            else if (ex == "not_connected") {
                this.flashAlert("couldn't connect to the server");
            }
            else {
                console.log(ex);
                this.flashAlert("sorry, thats not a valid move");
            }
        });
    }
    floatingAlertForBox(text, bx, by) {
        const p = this.board.rectForBox(bx, by);
        this.floatingAlertForPoint(text, p.center.x, p.center.y);
    }
    floatingAlertForPoint(text, x, y) {
        const a = new Chrome.FloatingAlertText(text, {
            ttl: 1000,
            x: x,
            y: y,
        });
        this.viewport.add(a);
        return a;
    }
    onWordSuccessful(response) {
        // show the change in score with a kind of floating
        // score box thing
        const m = response.moves[0];
        const isFirstMove = this.scoreDisplay.score == 0;
        this.floatingAlertForBox("+" + response.score, m.bx, m.by);
        if (response.credit_change > 0) {
            this.floatingAlertForBox(`+${response.credit_change}CR`, m.bx + 1, m.by);
        }
        // if we are in a timed game, then some extra updates are needed
        if (response.game && this.stopWatch) {
            this.stopWatch.remainingMs = response.game.sec_left * 1000;
            this.scoreDisplay.score = response.game.game_score;
        }
        else {
            this.scoreDisplay.score = response.total_score;
        }
        // set up an animation to fade the letters in
        const keys = response.moves.map((m) => this.board.dataSource.key(m.bx, m.by));
        this.board.fadeInLetters(keys);
        this.board.clearSelectedLetter();
        // fill the player tiles back up
        this.requestLettersIfNeeded();
        // if this was the users first move, then maybe we want to
        // do some conversion tracking
        if (isFirstMove) {
            if (this.options.user.user_id.endsWith(":re")) {
                // load the reddit tracking pixel
                $("#reddit-conversions").load("/user/reddit_pixel");
            }
        }
    }
    applyLocalSettings() {
        const box = Cookie.getJSON("settings.position");
        if (box && this.board) {
            const p = this.board.rectForBox(box.bx, box.by);
            this.viewport.setCenter(p.center.x, p.center.y);
            console.log(`starting at: ${box.bx}, ${box.by}`);
            // upda the url shown on the start page
            this.updateLinkUrl(box.bx, box.by);
        }
    }
    saveLocalSettings() {
        this.saveRateLimiter =
            this.saveRateLimiter ||
                debounce(() => {
                    // save the settings
                    const p = this.viewport.center;
                    const box = this.board.boxAt(p.x, p.y);
                    Cookie.set("settings.position", {
                        bx: box.bx,
                        by: box.by,
                        tile_set_hash: this.options.tile_set_hash,
                    }, {
                        path: "/",
                        expires: 365,
                    });
                    // update the app link
                    this.updateLinkUrl(box.bx, box.by);
                }, 400);
        this.saveRateLimiter();
    }
    // update the url that links to the users current location
    updateLinkUrl(bx, by) {
        const linkUrl = `http://babbl.xyz/p/${bx}/${by}`;
        $(".dialog a.location-link").attr("href", linkUrl).text(linkUrl);
    }
    logEvent(name, data) {
        this.socket.whenConnected().then(ws => {
            ws.send("log_event", {
                name: name,
                metadata: data,
            });
        });
    }
    // this will only fire on the first load when the authentication is complete
    // and the game is ready to go
    onLoadingComplete() {
        if (!this.scoreDisplay) {
            this.scoreDisplay = new Chrome.ScoreDisplay();
            this.viewport.add(this.scoreDisplay);
        }
        this.initializePanning();
    }
    flashAlert(text, ttl) {
        this.viewport.add(new Chrome.AlertPopup(text, { ttl: ttl || 1200 }));
        this.viewport.refresh();
    }
    requestLettersIfNeeded() {
        if (this.playerTiles.lettersNeededCount > 0 && this.socket.isConnected()) {
            this.socket.send("letters_needed", {
                n: this.playerTiles.lettersNeededCount -
                    this.board.dataSource.pendingCount,
            });
        }
    }
    set isLoading(v) {
        this._isLoading = !!v;
        if (this.loadingIndicator) {
            this.loadingIndicator._isVisible = this._isLoading;
        }
        this.viewport.refresh();
    }
    get isLoading() {
        return this._isLoading;
    }
    initializeSocket() {
        const params = {
            lang: this.options.user.lang,
            user_id: this.options.user.user_id,
            token: this.options.user.password,
        };
        const query = Object.keys(params)
            .map(k => `${k}=${params[k]}`)
            .join("&");
        let url = "/io?" + query;
        if (this.isLocal) {
            url = "wss://babbl.xyz" + url;
        }
        this.socket = new JS.JSONSocket({
            url: url,
            onOpen: () => {
                this.gameState = "connected";
            },
            onClose: () => {
                this.gameState = "connecting";
            },
        });
        this.socket.on("error", e => {
            console.log(e);
            this.isLoading = false;
            this.updateActionButtons();
            this.flashAlert(`uh oh: exception in ${e.event || "unknown"}`);
        });
        this.socket.on("console_log", txt => console.log("console_log: " + txt));
        this.socket.on("force_refresh", () => window.location.reload());
        this.socket.on("authenticated", response => {
            if (this.isFirstLoad) {
                console.log(`authenticated as ${response.user_id}`);
                this.onLoadingComplete();
            }
            this.scoreDisplay.score = response.total_score;
            if (response.yesterday_winner) {
                $("#winner span").text(response.yesterday_winner);
            }
        });
        this.socket.on("go_to", p => {
            if (this.viewport) {
                this.viewport.setCenter(p.bx, p.by);
                this.saveLocalSettings();
            }
        });
        this.socket.on("game_start", game => {
            console.log(`game_start: ${game.sec_left}s left`);
            // when we change the game state the UI will be set up automatically
            this.gameState = "timed_game";
            if (this.stopWatch) {
                this.stopWatch.remainingMs = game.sec_left * 1000;
            }
        });
        this.socket.on("game_end", result => {
            this.gameState = "connected";
            this.scoreDisplay.score = result.total_score;
            this.gameDialog.setScoreAndTime(result.game_score, result.game_time * 1000);
            this.gameDialog.show();
        });
        this.socket.on("invalidate_data", () => {
            this.resetPending();
            this.board.dataSource.invalidateAll();
            this.updateActionButtons();
            this.viewport.refresh();
        });
        // ping the server every so often to keep the socket alive
        // this should be build into the socket maybe?
        setInterval(() => {
            if (!this.socket.isConnected()) {
                return;
            }
            this.socket
                .send("ping", Date.now())
                .then(t => (this._ping = Date.now() - t));
        }, 1000 * 30);
        return this.socket;
    }
    set gameState(v) {
        if (this._gameState == v) {
            return;
        }
        if (this._gameState == "new") {
            if (v == "connected") {
                // connected for the first time
                this.socket.send("authenticate", {
                    user_id: this.options.user.user_id,
                    password: this.options.user.password,
                    version: this.options.version,
                });
            }
            else if (v == "connecting") {
                // ...
            }
            else {
                throw `Invalid gameState: ${this._gameState} -> ${v}`;
            }
        }
        else if (this._gameState == "connecting") {
            if (v == "connected") {
                // reconnected after a disconnect
                this.socket.send("authenticate", {
                    user_id: this.options.user.user_id,
                    password: this.options.user.password,
                    version: this.options.version,
                });
            }
            else {
                throw `Invalid gameState: ${this._gameState} -> ${v}`;
            }
        }
        else if (this._gameState == "connected") {
            if (v == "connecting") {
                // we have been disconnected
            }
            else if (v == "timed_game") {
                this.onGameStart();
            }
            else {
                throw `Invalid gameState: ${this._gameState} -> ${v}`;
            }
        }
        else if (this._gameState == "timed_game") {
            if (v == "connected") {
                this.onGameEnd();
            }
            else if (v == "connecting") {
                this.onGameEnd();
            }
            else {
                throw `Invalid gameState: ${this._gameState} -> ${v}`;
            }
        }
        console.log(`_gameState: ${this._gameState} -> ${v}`);
        this._gameState = v;
    }
    get gameState() {
        return this._gameState;
    }
    onGameStart() {
        if (this.stopWatch) {
            this.stopWatch.isRenderingFinished = true;
            this.stopWatch = null;
        }
        this.stopWatch = new Chrome.StopWatch({
            onTimerEnd: (t) => this.socket.send("end_game"),
        });
        this.scoreDisplay.score = 0;
        this.viewport.add(this.stopWatch);
        this.resetPending();
        // reposition the stopwatch and score
        if (this.stopWatch) {
            this.scoreDisplay.y = 65.5;
            this.stopWatch.y = 22.5;
        }
    }
    onGameEnd() {
        if (this.stopWatch) {
            this.stopWatch.isRenderingFinished = true;
            this.stopWatch = null;
        }
        this.resetPending();
        this.scoreDisplay.y = 22.5;
    }
    // different buttons are displayed depending on the state of the
    // game, if there are pending letters etc. This mrthod will update
    // which buttons are shown, and their position etc
    updateActionButtons() {
        if (this.board.dataSource.hasPending()) {
            $("a.button.commit").show();
            $("a.button.recall").show();
        }
        else {
            $("a.button.commit").hide();
            $("a.button.recall").hide();
        }
    }
    initializeDesktopControls() {
        $("#board-view canvas").mouseup(e => {
            if ($(".tile.sortable-fallback").length > 0) {
                const p = this.viewport.windowToViewport(e.offsetX, e.offsetY);
                const box = this.board.boxAt(p.x, p.y);
                this.onPlayerTileDropped(box);
            }
        });
        // show a pointer cursor while hovering a nearby-player arrow, so it
        // reads as clickable
        $("#board-view canvas").mousemove(e => {
            const isOverArrow = this.playerArrows.isPointOverArrow(e.clientX, e.clientY);
            $(e.currentTarget).css("cursor", isOverArrow ? "pointer" : "");
        });
        $("#board-view canvas").mouseleave(e => {
            $(e.currentTarget).css("cursor", "");
        });
        /*
            $(document).keydown(e => {
                if(e.key == 'w') {
                    this.movement = this.movement || {x:0, y:0};
                } else if(e.key == 'z') {
    
                }
            });
    
            $(document).mousemove(e => {
                if(!this.movement) {
                    return;
                }
    
                const s = this.viewport.rect.size;
                const v = new Vector(e.clientX - s.width/2, e.clientY - s.height/2);
                this.movement = v.toUnit().toObject();
            });
            */
    }
    initializePanning() {
        this.panningVelocity = { x: 0, y: 0 };
        const h = new Hammer(this.viewport.canvas);
        // need ot explicitly configure swipe off, and pan in all directions, because
        // by default hammer will seem to look for a vertical swipe guesture, and which
        // will swollow the pan and make the interface seem unresponsive
        h.get("swipe").set({ enable: false });
        h.get("pan").set({ direction: Hammer.DIRECTION_ALL });
        h.on("tap", e => {
            if (this.playerArrows.handleTap(e.center.x, e.center.y)) {
                this.saveLocalSettings();
                return;
            }
            this.onTap(e);
        });
        h.on("pan", e => {
            // we don't want to process this event if the panstart hasn't trigger, or
            // if this is the 'final' pan event, because it can have some strange data
            if (!this.dragStart || e.isFinal) {
                return;
            }
            // there are two possible modes on the pan event - one where the user is moving
            // around the board, and one where they are moving one of the pending letters
            // to a new position. Detecting which one the drag will be is done in the
            // 'panstart' event
            if (this.dragStart.letterToMove) {
                this.onDragLetter(e);
            }
            else {
                this.onPanCanvas(e);
                this.saveLocalSettings();
            }
        });
        h.on("panstart", e => {
            this.dragStart = {
                x: this.viewport.center.x,
                y: this.viewport.center.y,
                deltaX: e.deltaX,
                deltaY: e.deltaY,
                letterToMove: null,
            };
            // find out what box the user has tapped on - if it is one of their
            // pending peices, then we will be moving that, instead of panning
            // around the board.
            const p = this.viewport.windowToViewport(e.center.x, e.center.y);
            const b = this.board.boxAt(p.x, p.y);
            if (this.board.dataSource.isPending(b.bx, b.by)) {
                this.dragStart.letterToMove = b;
                this.board.clearSelectedLetter();
            }
        });
        // need to do this to stop pull to refresh and other events happening
        $(this.viewport.canvas).on("touchmove", e => e.preventDefault());
        $("#player-bar").on("touchmove", e => {
            if (this.isUsingMouse) {
                return;
            }
            const t = e.originalEvent.touches[0];
            const c = { x: t.clientX, y: t.clientY };
            const p = this.viewport.windowToViewport(c.x, c.y);
            if (p.y < this.viewport.rect.bounds.bottom - 64) {
                const box = this.board.boxAt(p.x, p.y);
                this.onPlayerTileDrag(e, box);
            }
            else {
                this.board.hoverBox = null;
            }
        });
        $("#player-bar").on("touchend", e => {
            if (this.isUsingMouse) {
                return;
            }
            if (this.board.hoverBox) {
                this.onPlayerTileDropped(this.board.hoverBox);
            }
        });
    }
    onPlayerTileDrag(e, box) {
        if (!this.board.dataSource.isSet(box.bx, box.by)) {
            this.board.hoverBox = box;
        }
        else {
            this.board.hoverBox = null;
        }
        this.viewport.refresh();
    }
    onPlayerTileDropped(box) {
        const c = this.playerTiles.selectedLetter || "";
        if (c && this.board.dataSource.setPending(box.bx, box.by, c)) {
            // setPending will return true if the letter was dropped
            // in a valid spot - in this case we remove the selectedLetter
            // from the player tiles
            this.playerTiles.removeSelected();
        }
        this.updateActionButtons();
        this.board.hoverBox = null;
        this.viewport.refresh();
    }
    onTap(e) {
        const p = this.viewport.windowToViewport(e.center.x, e.center.y);
        const b = this.board.boxAt(p.x, p.y);
        if (this.board.dataSource.isPending(b.bx, b.by)) {
            this.playerTiles.unselect();
            if (this.board.selectedLetter &&
                this.board.selectedLetter.bx == b.bx &&
                this.board.selectedLetter.by == b.by) {
                // the user tapped the selected letter, so we want
                // to deselected it
                this.board.clearSelectedLetter();
            }
            else {
                this.board.setSelectedLetter(b.bx, b.by);
            }
        }
        else if (this.board.selectedLetter) {
            const dest = this.board.dataSource.moveLetter({ x: this.board.selectedLetter.bx, y: this.board.selectedLetter.by }, { x: b.bx, y: b.by });
            this.board.clearSelectedLetter();
        }
        else if (this.playerTiles.selectedLetter) {
            // if the player taps on the board, by default nothing will happen, but if they
            // have selected a letter, then that letter will be placed on the board in a
            // 'pending' state (meaning it hasn't been submitted to the server or commited
            // to the database).
            const c = this.playerTiles.selectedLetter;
            if (c && this.board.dataSource.setPending(b.bx, b.by, c)) {
                this.playerTiles.removeSelected();
                this.updateActionButtons();
            }
        }
    }
    onPanCanvas(e) {
        this.panningVelocity = { x: e.overallVelocityX, y: e.overallVelocityY };
        this.viewport.setCenter(this.dragStart.x + (this.dragStart.deltaX - e.deltaX), this.dragStart.y + (this.dragStart.deltaY - e.deltaY));
        this.viewport.refresh();
        if (this.board.shouldUseFastRendering) {
            if (this._t) {
                clearTimeout(this._t);
                this._t = null;
            }
            this._t = setTimeout(() => {
                this.board.shouldUseFastRendering = false;
                this.viewport.refresh();
            }, 250);
        }
        if (this.viewport.isSlow) {
            this.board.shouldUseFastRendering = true;
        }
    }
    onDragLetter(e) {
        const p = this.viewport.windowToViewport(e.center.x, e.center.y);
        const b = this.board.boxAt(p.x, p.y);
        const destPoint = this.board.dataSource.moveLetter({
            x: this.dragStart.letterToMove.bx,
            y: this.dragStart.letterToMove.by,
        }, { x: b.bx, y: b.by });
        this.dragStart.letterToMove = { bx: destPoint.x, by: destPoint.y };
    }
    update() {
        if (this.panningVelocity) {
            this.updatePanVelocity();
        }
        if (this.movement) {
            const p = this.viewport.center;
            this.viewport.setCenter(p.x + this.movement.x * 5.0, p.y + this.movement.y * 5.0);
            this.viewport.refresh();
        }
    }
    // when panning around on touch interfaces, we want there to be a bit of momentum
    // so the movement keeps going after the user lets go. Unfortunately this is not
    // supported by hammer.js by default, so we implement this behaviour here. Hammer.js
    // gives the speed of the touch, so after the pan is finished, we just keep applying
    // that movement, while reducing it until is gets under some limit
    updatePanVelocity() {
        const v = this.panningVelocity || { x: 0, y: 0 };
        const s = Math.sqrt(Math.pow(v.x, 2) + Math.pow(v.y, 2));
        if (s > 0.1 && !this.isUsingMouse) {
            const p = this.viewport.center;
            this.viewport.setCenter(Math.round(p.x - v.x * 10), Math.round(p.y - v.y * 10));
            this.viewport.refresh();
            this.panningVelocity = {
                x: v.x * 0.8,
                y: v.y * 0.8,
            };
        }
    }
}
